import { Button, Grid, TextField, Switch, FormControlLabel, Box, Typography, Chip, Paper, Divider } from "@mui/material";
import dayjs from "dayjs";
import { useState, useEffect, useRef } from "react";
import "dayjs/locale/es";
import Autocomplete from '@mui/material/Autocomplete';
import esArray from "src/general_components/functionEsArray";
import SearchIcon from '@mui/icons-material/Search';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import SelectAllIcon from '@mui/icons-material/SelectAll';
import DeselectIcon from '@mui/icons-material/Deselect';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { getCuentasLocalizaciones } from "src/projects/gestion_comercial/helpers/CuentasLocalizaciones";

// Establecer español como idioma predeterminado
dayjs.locale("es");

const BuscadorGeneral = (data) => {
  const { setSearchQuery,
    setBuscadorEjecutado,
    clienteSeleccionado,
    setClienteSeleccionado,
    setOptions,
    options,
    setIdsCuentasLocalizaciones,
    setActualizarListado } = data;
  const [buscador, setBuscador] = useState("");
  const [sectoresList, setSectoresList] = useState([]);
  const [sectoresSeleccionados, setSectoresSeleccionados] = useState([]);

  const [estadoPeticion, setEstadoPeticion] = useState(localStorage.getItem('estadoPeticionModelos') === 'true');
  const intervalRef = useRef(null); // 🗂️ Referencia para el intervalo

  // Estados para Número
  const [habilitarRangoNumero, setHabilitarRangoNumero] = useState(false);
  const [numero, setNumero] = useState("");
  const [numeroDesdeConcat, setNumeroDesdeConcat] = useState("");
  const [numeroHastaConcat, setNumeroHastaConcat] = useState("");

  // Estados para Fecha
  const [habilitarRangoFecha, setHabilitarRangoFecha] = useState(false);
  const [fecha, setFecha] = useState("");
  const [fechaDesdeConcat, setFechaDesdeConcat] = useState("");
  const [fechaHastaConcat, setFechaHastaConcat] = useState("");
  const [switchBusquedaEnDigitalizaciones, setSwitchBusquedaEnDigitalizaciones] = useState(false);



  useEffect(() => {
    if (estadoPeticion) return; // 🚩 Detiene el efecto si ya está en true

    intervalRef.current = setInterval(() => {
      const estadoActual = localStorage.getItem('estadoPeticionModelos') === 'true';


      if (estadoActual) {
        setEstadoPeticion(true);
        clearInterval(intervalRef.current); // ✅ Detiene el intervalo
      }
    }, 1000); // Verifica cada segundo

    return () => clearInterval(intervalRef.current); // Limpia si el componente se desmonta
  }, [estadoPeticion]);




  const parseSectores = (result) =>
    Object.entries(result).map(([, value]) => ({ ...value, label: value.descripcion }));

  // Cargar sectores cuando cambia el cliente seleccionado (multi-cuenta)
  useEffect(() => {
    if (clienteSeleccionado?.id_cuentas) {
      getCuentasLocalizaciones(clienteSeleccionado.id_cuentas).then(result => {
        setSectoresList(parseSectores(result));
        setSectoresSeleccionados([]);
        setIdsCuentasLocalizaciones([]);
      });
    } else if (esArray(user_cuentas).length !== 1) {
      setSectoresList([]);
      setSectoresSeleccionados([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clienteSeleccionado]);

  // Cargar sectores para usuario de cuenta única al montar
  useEffect(() => {
    if (estadoPeticion && esArray(user_cuentas).length === 1) {
      const idCuenta = esArray(user_cuentas)[0]?.id_cuentas;
      if (idCuenta) {
        getCuentasLocalizaciones(idCuenta).then(result => {
          setSectoresList(parseSectores(result));
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [estadoPeticion]);

  const handleSectoresChange = (newValue) => {
    setSectoresSeleccionados(newValue);
    if (newValue.length > 0) {
      setIdsCuentasLocalizaciones(newValue.map(s => s.id));
    } else {
      setIdsCuentasLocalizaciones([]);
    }
  };

  const handleSearch = () => {
    setSearchQuery({
      input_general: buscador,
      input_numerico: numero,
      input_numero_desde: numeroDesdeConcat,
      input_numero_hasta: numeroHastaConcat,
      input_fecha: fecha,
      input_fecha_desde: fechaDesdeConcat,
      input_fecha_hasta: fechaHastaConcat,
      busqueda_digitalizaciones: switchBusquedaEnDigitalizaciones? "1":"0"
    });
    setBuscadorEjecutado(true);
    setActualizarListado(true);
  };

  const handleClear = () => {
    setSearchQuery("");
    setBuscador("");
    setClienteSeleccionado(null);
    setBuscadorEjecutado(false);
    setSectoresSeleccionados([]);
    if (esArray(user_cuentas).length !== 1) setSectoresList([]);
    setOptions({
      ...options,
      sinFilas: true,
      idElementData: false
    });
    setIdsCuentasLocalizaciones([]);
    setActualizarListado(false);
  };

  const handleChange = (e) => {
    setBuscador(e.target.value);
  };

  // const [clienteSeleccionado, setClienteSeleccionado] = useState(null);
  const [clientesList, setClientesList] = useState([]);

  const handleClienteSeleccionado = (cliente) => {
    setIdsCuentasLocalizaciones([]);
    setClienteSeleccionado(cliente);
  };

  useEffect(() => {
    const getClientes = async () => {
      var clientes = [];
      let cuentas = esArray(JSON.parse(localStorage.getItem("siam-service-getCuentasGenericas"))?.cuentas);
      let condicionIn = false

      //clientes = await getCuentasJuridicas(cuentas,condicionIn);

      let clients = esArray(JSON.parse(localStorage.getItem("siam-cuentas_personas_juridicas"))?.cuentas_personas_juridicas);
      clientes = clients.filter((cliente) =>
        cuentas.find(
          (cuenta) => {
            if (condicionIn === true) {
              return cuenta.id_cuentas === cliente.id_cuentas

            } else {
              return cuenta.id_cuentas !== cliente.id_cuentas
            }
          }
        )
      );

      const user_cuentas = JSON.parse(
        localStorage.getItem("siam-user-cuentas")
      );
      let userCuentasStorage = esArray(user_cuentas);

      if (userCuentasStorage.length < 2) {
        let usersCuentasModificado = [
          { usuarios_cuentas: userCuentasStorage[0] },
        ];
        userCuentasStorage = usersCuentasModificado;
      }
      if (user_cuentas.length > 0) {
        let clientesFilter = clientes.filter((cliente) =>
          userCuentasStorage.find(
            (obj) => obj.usuarios_cuentas.id_cuentas === cliente.id_cuentas
          )
        );

        if (clientesFilter && clienteSeleccionado) {
          let objClienteSelected = clientesFilter.filter(cliente => cliente.id_cuentas === clienteSeleccionado)
          setClienteSeleccionado(objClienteSelected[0]);
        }
        setClientesList(esArray(clientesFilter));

      } else {
        if (clienteSeleccionado) {

          let objClienteSelected = clientes.filter(cliente => cliente.id_cuentas === clienteSeleccionado)
          setClienteSeleccionado(objClienteSelected[0]);
        }
        setClientesList(esArray(clientes));

      }
    }
    getClientes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [estadoPeticion]);


  const user_cuentas = JSON.parse(
    localStorage.getItem("siam-user-cuentas")
  );

  const handleChangeSwitchNumerico = () => {
    if (habilitarRangoNumero) {
      setNumeroDesdeConcat("");
      setNumeroHastaConcat("");
    } else {
      setNumero("");
    }
    setHabilitarRangoNumero(!habilitarRangoNumero);
  };

  const handleChangeSwitchFecha = () => {
    if (habilitarRangoFecha) {
      setFechaDesdeConcat("");
      setFechaHastaConcat("");
    } else {
      setFecha("");
    }
    setHabilitarRangoFecha(!habilitarRangoFecha);
  };

    const handleChangeSwitchBusquedaEnDigitalizaciones = () => {

    setSwitchBusquedaEnDigitalizaciones(!switchBusquedaEnDigitalizaciones);
  };


  const isMultiAccount = esArray(user_cuentas).length !== 1;

  return (
    <Paper elevation={2} sx={{ p: 2.5, borderRadius: 2 }}>
      {/* Encabezado */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
        <FilterAltIcon sx={{ color: 'text.secondary', fontSize: 18 }} />
        <Typography variant="subtitle2" sx={{ color: 'text.secondary', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5 }}>
          Parámetros de búsqueda
        </Typography>
      </Box>

      {/* Fila 1: Cliente + Sector */}
      <Grid container spacing={2}>
        {isMultiAccount && (
          <Grid item xs={12} md={6}>
            <AutoCompleteClientes
              clientes={clientesList}
              onClienteSeleccionado={handleClienteSeleccionado}
              clienteSeleccionado={clienteSeleccionado}
            />
          </Grid>
        )}
        <Grid item xs={12} md={isMultiAccount ? 6 : 12}>
          <Box sx={{ border: '1px solid rgba(0,0,0,0.23)', borderRadius: 1, p: 1.5, position: 'relative', '&:hover': { borderColor: sectoresList.length > 0 ? 'rgba(0,0,0,0.87)' : 'rgba(0,0,0,0.23)' } }}>
            <Typography variant="caption" sx={{ position: 'absolute', top: -9, left: 10, px: 0.5, bgcolor: 'background.paper', color: 'text.secondary', lineHeight: 1, fontSize: '0.75rem' }}>
              Sector
            </Typography>
            <Autocomplete
              multiple
              size="small"
              options={sectoresList}
              value={sectoresSeleccionados}
              onChange={(_, newValue) => handleSectoresChange(newValue)}
              getOptionLabel={(option) => option.id + ' - ' + (option.descripcion || option.label || '')}
              isOptionEqualToValue={(opt, val) => opt.id === val.id}
              disableCloseOnSelect
              disabled={sectoresList.length === 0}
              noOptionsText="Sin sectores disponibles"
              renderTags={(tagValue, getTagProps) =>
                tagValue.map((option, index) => (
                  <Chip {...getTagProps({ index })} key={option.id} label={option.descripcion || option.label} size="small" sx={{ fontSize: '0.7rem' }} />
                ))
              }
              renderInput={(params) => (
                <TextField {...params} placeholder={sectoresList.length === 0 && isMultiAccount ? 'Seleccione un cliente primero' : 'Buscar sector...'} variant="standard" InputProps={{ ...params.InputProps, disableUnderline: true }} />
              )}
            />
            {sectoresList.length > 0 && (
              <Box sx={{ display: 'flex', alignItems: 'center', borderTop: '1px solid rgba(0,0,0,0.08)', mt: 0.75, pt: 0.5, gap: 0.5 }}>
                <Button size="small" variant="text" startIcon={<SelectAllIcon fontSize="small" />}
                  onClick={() => handleSectoresChange(sectoresList)}
                  disabled={sectoresSeleccionados.length === sectoresList.length}
                  sx={{ fontSize: '0.68rem', py: 0.25, minWidth: 0 }}>
                  Todos
                </Button>
                <Button size="small" variant="text" color="secondary" startIcon={<DeselectIcon fontSize="small" />}
                  onClick={() => handleSectoresChange([])}
                  disabled={sectoresSeleccionados.length === 0}
                  sx={{ fontSize: '0.68rem', py: 0.25, minWidth: 0 }}>
                  Ninguno
                </Button>
                <Typography variant="caption" color="text.secondary" sx={{ ml: 'auto' }}>
                  {sectoresSeleccionados.length === 0 ? 'Todos los sectores' : `${sectoresSeleccionados.length} de ${sectoresList.length}`}
                </Typography>
              </Box>
            )}
          </Box>
        </Grid>
      </Grid>

      <Divider sx={{ my: 2 }} />

      {/* Fila 2: Texto + Número + Fecha */}
      <Grid container spacing={2} alignItems="flex-start">
        {/* Búsqueda general */}
        <Grid item xs={12} md={4}>
          <TextField
            id="nombre"
            fullWidth
            size="small"
            label="Búsqueda general"
            variant="outlined"
            value={buscador}
            onChange={handleChange}
          />
        </Grid>

        {/* Número */}
        <Grid item xs={12} md={4}>
          <Box sx={{ border: '1px solid rgba(0,0,0,0.23)', borderRadius: 1, px: 1.5, pt: 0.5, pb: 1.5 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Typography variant="caption" sx={{ color: 'text.secondary', fontSize: '0.72rem' }}>Número</Typography>
              <FormControlLabel
                control={<Switch size="small" checked={habilitarRangoNumero} onChange={handleChangeSwitchNumerico} />}
                label={<Typography variant="caption" sx={{ fontSize: '0.72rem' }}>Rango</Typography>}
                sx={{ mr: 0 }}
              />
            </Box>
            {habilitarRangoNumero ? (
              <Grid container spacing={1}>
                <Grid item xs={6}>
                  <TextField fullWidth size="small" type="number" label="Desde" variant="outlined"
                    value={numeroDesdeConcat} onChange={(e) => setNumeroDesdeConcat(e.target.value)} />
                </Grid>
                <Grid item xs={6}>
                  <TextField fullWidth size="small" type="number" label="Hasta" variant="outlined"
                    value={numeroHastaConcat} onChange={(e) => setNumeroHastaConcat(e.target.value)} />
                </Grid>
              </Grid>
            ) : (
              <TextField fullWidth size="small" type="number" label="Número" variant="outlined"
                value={numero} onChange={(e) => setNumero(e.target.value)} />
            )}
          </Box>
        </Grid>

        {/* Fecha */}
        <Grid item xs={12} md={4}>
          <Box sx={{ border: '1px solid rgba(0,0,0,0.23)', borderRadius: 1, px: 1.5, pt: 0.5, pb: 1.5 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Typography variant="caption" sx={{ color: 'text.secondary', fontSize: '0.72rem' }}>Fecha</Typography>
              <FormControlLabel
                control={<Switch size="small" checked={habilitarRangoFecha} onChange={handleChangeSwitchFecha} />}
                label={<Typography variant="caption" sx={{ fontSize: '0.72rem' }}>Rango</Typography>}
                sx={{ mr: 0 }}
              />
            </Box>
            {habilitarRangoFecha ? (
              <Grid container spacing={1}>
                <Grid item xs={6}>
                  <TextField fullWidth size="small" type="date" label="Desde" variant="outlined"
                    InputLabelProps={{ shrink: true }} value={fechaDesdeConcat}
                    onChange={(e) => setFechaDesdeConcat(e.target.value)} />
                </Grid>
                <Grid item xs={6}>
                  <TextField fullWidth size="small" type="date" label="Hasta" variant="outlined"
                    InputLabelProps={{ shrink: true }} value={fechaHastaConcat}
                    onChange={(e) => setFechaHastaConcat(e.target.value)} />
                </Grid>
              </Grid>
            ) : (
              <TextField fullWidth size="small" type="date" label="Fecha" variant="outlined"
                InputLabelProps={{ shrink: true }} value={fecha}
                onChange={(e) => setFecha(e.target.value)} />
            )}
          </Box>
        </Grid>
      </Grid>

      {/* Fila 3: Opciones + Acciones */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 2, flexWrap: 'wrap', gap: 1 }}>
        <FormControlLabel
          control={<Switch size="small" checked={switchBusquedaEnDigitalizaciones} onChange={handleChangeSwitchBusquedaEnDigitalizaciones} />}
          label={<Typography variant="body2">Búsqueda en digitalizaciones</Typography>}
        />
        <Box sx={{ display: 'flex', gap: 1 }}>
          <Button variant="outlined" color="secondary" size="small" startIcon={<RestartAltIcon />} onClick={handleClear}>
            Limpiar
          </Button>
          <Button variant="contained" color="primary" size="small" startIcon={<SearchIcon />} onClick={handleSearch}>
            Buscar
          </Button>
        </Box>
      </Box>
    </Paper>
  );
};
export default BuscadorGeneral;

const AutoCompleteClientes = ({ clientes, onClienteSeleccionado, clienteSeleccionado }) => {
  return (
    <Autocomplete
      options={clientes || []}
      onChange={(event, value) => onClienteSeleccionado(value)}
      fullWidth
      getOptionLabel={(option) => option.id_cuentas + ' - ' + option.razon_social || ""}
      value={clienteSeleccionado}
      renderInput={(params) => (
        <TextField {...params}
          label="Cliente"
        // disabled={ editar || disabled? true : false}
        />
      )}


    />
  );
};


